// Script de remplacement minimaliste pour modal-master.js
(function() {
  // Définir les variables globales nécessaires pour que le thème fonctionne
  window.t = 3;
  window.p = 'ov';
  window.y = 5;
  window.productCartForm = "productCartForm";
  window.allSliders = "allSliders";
  window.isModalOpened = true; // Important : définir à true pour éviter l'ouverture de la modal
  
  // Ne rien faire d'autre - pas de traitement asynchrone, pas de vérification de domaine
  // Pas d'appel à des fonctions externes, pas de manipulation du DOM
})(); 